export default __webpack_public_path__ + "static/media/NIE_touchpoint_01.da7b64f6.mp4";